import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { t, isMobile, throttle } from '@insight/toolkit-utils';
import Button from '../../Button/Button';

const SpecificationsTechOverview = (props) => {
  const {
    description,
    scrollIntoView,
    history,
    elementId,
    targetElement,
    handleClick,
  } = props;

  const [isOnMobile, setIsMobile] = useState(isMobile());

  useEffect(() => {
    const onResize = throttle(() => {
      setIsMobile(isMobile());
    }, 250);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const onClickHandler = () => {
    if (isOnMobile) {
      scrollIntoView?.(elementId);
      return;
    }
    scrollIntoView?.(targetElement);
    history?.push?.({
      hash: `#${elementId}`,
    });
  };

  if (!description) return null;
  return (
    <section className="c-product-specifications__tech-overview">
      <strong>{t('Tech overview')}</strong>
      <div>{description}</div>
      <div>
        <Button
          className="c-product-specifications__anchor"
          color="inline-link"
          onClick={handleClick || onClickHandler}
        >
          {t('View full product specifications')}
        </Button>
      </div>
    </section>
  );
};

export default SpecificationsTechOverview;

SpecificationsTechOverview.propTypes = {
  description: PropTypes.string,
  scrollIntoView: PropTypes.func,
  history: PropTypes.object,
  elementId: PropTypes.string,
  targetElement: PropTypes.string,
  handleClick: PropTypes.func,
};

SpecificationsTechOverview.defaultProps = {
  description: '',
  scrollIntoView: () => {},
  history: {},
  elementId: 'tab-specifications',
  targetElement: 'tabs',
  handleClick: null,
};
